<template>
    <div>
        <modal-dialog title="Log in to your account" classes="modal--centered" :show="showModal" @close="showModal = false">
            <slot></slot>
            <div class="form-group">
                <label>Email Address</label>
                <input class="form-control" type="email" v-model="email"> 
                <ul class="form-errors"  v-if="errors.email">
                    <li v-for="(error, index) in errors.email" :key="index">
                        {{ error }}
                    </li>
                </ul>
            </div>
            <div class="form-group">
                <label>Password</label>
                <input class="form-control" type="password" v-model="password">
                <ul class="form-errors"  v-if="errors.password">
                    <li v-for="(error, index) in errors.password" :key="index">
                        {{ error }}
                    </li>
                </ul>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <button class="btn btn-blue" @click="showModal = false">Close</button>
                </div>
                <div class="col-md-6 text-right">
                    <button @click="login" class="btn btn-green" :disabled="processing">
                        <template v-if="processing">
                            <i class="fa fa-refresh fa-spin"></i> Logging in
                        </template>
                        <template v-else>
                            Sign in
                        </template>
                    </button>
                </div>
            </div>
        </modal-dialog>
    </div>
</template>

<script>
    import ModalDialog from '../ModalDialog.vue';
    import Auth from '../../../Services/Auth.js';

    export default {
        components: {
            ModalDialog
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            redirect: {
                type: String,
                default: null,
            }
        },
        watch: {
            show() {
                this.showModal = this.show;
            }
        },
        mounted() {
            this.showModal = this.show;
        },
        methods: {
            login() {
                this.errors = [];
                this.processing = true;

                // The state of our csrf token might have changed, so we grab a new one
                // based on the current user session.
                axios.get('/api/csrf-token').then(response => {
                    this.service.login(this.email, this.password, response.data.token).then(response => {
                        this.processing = false;
                        if (this.redirect) {
                            window.location = this.redirect;
                        } else {
                            this.$emit('loggedin', true);
                        }
                    }).catch(errors => {
                        this.errors = errors.response.data.errors;
                        this.processing = false;
                    });
                });

            }
        },
        data() {
            return {
                showModal: false,
                email: null,
                password: null,
                errors: [],
                processing: false,
                service: Auth
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/Modals/LoginModal.vue